import React, { useEffect, useState } from 'react';
import CircledOption from './CircledOption'

/**
 * Map recursively to set choices
 * and deploy results
 * 
 * @param {*} decision 
 * @param {*} deployedSelection 
 * @returns 
 */
 export const deployDecisions = (decision, deployedSelection) => {
    
    if(!decision) return []

    // deployedSelection.choosed
    const updatedDecision = decision.decisions.map((rootDecision, index)=> {
        
        const nestedDecisions = rootDecision.decisions && rootDecision.decisions.length > 0 ? 
            deployDecisions(rootDecision, deployedSelection) : []
        

        const isThisDeployed = deployedSelection.choosed || 
            rootDecision.id === deployedSelection.id || 
            deepSearchByID(rootDecision.decisions, 'decisions', deployedSelection.id )
        
        

        return {
            ...rootDecision,
            choosed: !isThisDeployed && rootDecision.choosed ? true : isThisDeployed,
            parentIndex: index,
            decisions: nestedDecisions 
        }

    })

    return updatedDecision
    
}

/**
 * Deap seach by ID
 * @param {*} haystack 
 * @param {*} key 
 * @param {*} id 
 * @returns 
 */
 export const deepSearchByID = (haystack, key, id) => {
    return haystack.some((stack) => {
        if(stack.id == id) return true
        else if(stack[key]) return deepSearchByID(stack[key],key, id)
        else return false
    })
}
/**
 * 
 * @param {*} decisions 
 * @returns 
 */
 export const isItDeployed = (decisions) => {

    const hasChildDesisions = decisions.some((nested) => {
        return nested.decisions.length > 0                    
    })
    return hasChildDesisions ? 
        decisions.every((itm) => itm.choosed) :
        decisions.some((itm) => itm.choosed)
}


const DecisionCircles = (props) => {

    const {categories, callback, disabled=false, onSelectHandle} = props
    /** States */
    const [categoryID, setCategoryID ] = useState(false)
    const [decisionCategories, setDecisionCategories ] = useState()

    useEffect(()=> { 
        setCategoryID()  
        setDecisionCategories(categories)      
    },[])

    useEffect(()=> {
        setDecisionCategories(categories)   

    },[categories])

    const handleCatSelection = (index) => {
        if(!disabled){
            setCategoryID(index)        
            onSelectHandle(index)
        }  
    }

    /** */
    const handleAnswerCallback = (decisionIndex, answer) => {
        
        const callbackObject = {
            ...decisionCategories[categoryID], 
            decisions: decisionCategories[categoryID].decisions[decisionIndex], 
            answer
        }
        callback(callbackObject);
    }

    return (
        <div className='categories' >
            {
                decisionCategories && decisionCategories.map((cat, index)=> {
                    
                    const hasChildDesisions = cat.decisions.some((nested) => {
                        return nested.decisions.length > 0                    
                    })

                    return (
                        <CircledOption 
                            key={index}
                            data={cat}
                            text={cat.name} 
                            currentIndex={index}
                            dots={hasChildDesisions} 
                            className={(cat.done ? 'done' : '')}
                            itemSelected={(categoryID===index  ? true : false )}
                            onClickHandle={handleCatSelection}
                            answerCallback={handleAnswerCallback}
                            disabled={disabled}
                        />
                    )
                })
            }
        </div>
    )

}

export default DecisionCircles;